import Alert from 'common/components/alert/Alert';
import Modal from 'common/components/modal/Modal';
import AlertType from 'common/types/AlertType';
import React, { Fragment, useEffect, useState } from 'react';
import { Button, FormControl, FormGroup, FormLabel } from 'react-bootstrap';
import { DeactivateViews } from './DeactivateViews';

interface IDeactivatePresenter {
  view: DeactivateViews;
  onStart: () => void;
  onConfirm: (name: string) => void;
  onConfirmWithApps: (name: string) => void;
  onCancel: () => void;
  message: string;
  type: AlertType;
  fullName: string;
  isDeactivating: boolean;
}

const DeactivatePresenter = (props: IDeactivatePresenter) => {
  const [confirmation, setConfirmation] = useState('');

  const handleConfirmationChange = (e: React.ChangeEvent<HTMLInputElement>) =>
    setConfirmation(e.target.value);

  const { view } = props;
  useEffect(() => {
    if (view === DeactivateViews.hidden) {
      setConfirmation('');
    }
  }, [view]);

  const handleCancel = () => {
    props.onCancel();
    setConfirmation('');
  };

  let confirmBtn: React.ReactNode | null = null;
  if (view === DeactivateViews.confirming) {
    confirmBtn = (
      <Button
        variant='danger'
        onClick={() => {
          props.onConfirm(confirmation);
        }}
        disabled={props.isDeactivating}
      >
        Deactivate account
      </Button>
    );
  } else if (view === DeactivateViews.confirmingWithApps) {
    confirmBtn = (
      <Button
        variant='danger'
        onClick={() => {
          props.onConfirmWithApps(confirmation);
        }}
        disabled={props.isDeactivating}
      >
        Deactivate account and withdraw applications
      </Button>
    );
  }

  const isDisplayingModal = view !== DeactivateViews.hidden;

  return (
    <>
      {!isDisplayingModal && props.message && (
        <Alert type={props.type}>{props.message}</Alert>
      )}
      <Button variant='outline-danger' onClick={props.onStart}>
        Deactivate Account
      </Button>
      <Modal
        show={isDisplayingModal}
        toggle={handleCancel}
        title='Deactivate account'
        body={
          <>
            {isDisplayingModal && props.message && (
              <Alert type={props.type}>{props.message}</Alert>
            )}
            <p>
              Please re-enter the name on your profile below to confirm that you
              would like to deactivate your account:
            </p>
            <FormGroup>
              <FormLabel>{props.fullName}</FormLabel>
              <FormControl
                value={confirmation}
                onChange={handleConfirmationChange}
                disabled={props.isDeactivating}
              />
            </FormGroup>
            <div className='d-flex'>
              <Button
                variant='outline-primary'
                className='mr-auto'
                onClick={handleCancel}
                disabled={props.isDeactivating}
              >
                Cancel
              </Button>
              {confirmBtn}
            </div>
          </>
        }
      />
    </>
  );
};

export default DeactivatePresenter;
